import { render, staticRenderFns } from "./LastStockUpdate.vue?vue&type=template&id=d6a3896e&scoped=true&"
import script from "./LastStockUpdate.vue?vue&type=script&lang=js&"
export * from "./LastStockUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LastStockUpdate.vue?vue&type=style&index=0&id=d6a3896e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a3896e",
  null
  
)

export default component.exports